import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'

const isFlagOn = (value) =>
  value === true || value === 1 || value === '1'

const EditSubjectModal = ({ show, handleClose, subject, onSubjectUpdated }) => {
  const [updatedSubject, setUpdatedSubject] = useState({
    subject_name: '',
    course_id: '',
    is_theory: 0,
    is_practical: 0,
  })
  const [courses, setCourses] = useState([])

  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  }, [])

  useEffect(() => {
    if (subject) {
      setUpdatedSubject({
        subject_name: subject.subject_name || '',
        course_id: subject.course_id || '',
        is_theory: isFlagOn(subject.is_theory) ? 1 : 0,
        is_practical: isFlagOn(subject.is_practical) ? 1 : 0,
      })
    }
  }, [subject])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setUpdatedSubject((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubjectTypeChange = (field, checked) => {
    setUpdatedSubject((prev) => ({
      ...prev,
      [field]: checked ? 1 : 0,
    }))
  }

  const handleSaveChanges = async () => {
    try {
      const response = await ApiEndpoints.editSubject(subject.id, {
        subject_name: updatedSubject.subject_name,
        course_id: updatedSubject.course_id,
        is_theory: updatedSubject.is_theory ? 1 : 0,
        is_practical: updatedSubject.is_practical ? 1 : 0,
      })
      toast.success(response.data.result)
      handleClose()
      if (typeof onSubjectUpdated === 'function') {
        onSubjectUpdated()
      }
    } catch (error) {
      toast.error(error.response?.data?.result)
    }
  }

  return (
    <Modal className="edit-subject-modal" show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton 
        closeVariant="white"
        className="bg-warning text-dark">
        <Modal.Title>Edit Subject</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Subject Name</Form.Label>
            <Form.Control
              type="text"
              name="subject_name"
              value={updatedSubject.subject_name}
              onChange={handleInputChange}
              placeholder="Enter Subject Name"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Course</Form.Label>
            <div style={{ position: 'relative' }}>
              <Typeahead
                id="edit-subject-course"
                labelKey="name"
                onChange={(selected) => {
                  const course = selected[0]
                  handleInputChange({
                    target: {
                      name: 'course_id',
                      value: course ? course.id : '',
                    },
                  })
                }}
                options={courses}
                placeholder="Select Course"
                positionFixed
                selected={
                  updatedSubject.course_id
                    ? courses.filter(
                        (course) =>
                          String(course.id) === String(updatedSubject.course_id),
                      )
                    : []
                }
                inputProps={{
                  style: {
                    borderRadius: '8px',
                    border: '1px solid #D1D3D4',
                    fontSize: '14px',
                    minHeight: '38px',
                  },
                }}
              />
            </div>
          </Form.Group>

          <div className="d-flex gap-4">
            <Form.Check
              type="checkbox"
              id="edit-subject-theory"
              label="Theory"
              checked={updatedSubject.is_theory === 1}
              onChange={(e) =>
                handleSubjectTypeChange('is_theory', e.target.checked)
              }
            />
            <Form.Check
              type="checkbox"
              id="edit-subject-practical"
              label="Practical"
              checked={updatedSubject.is_practical === 1}
              onChange={(e) =>
                handleSubjectTypeChange('is_practical', e.target.checked)
              }
            />
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="warning" onClick={handleSaveChanges}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EditSubjectModal
